var _defs, _path, _path2, _path3, _path4, _path5, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRazorpayTrusted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 72",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Razorpay Trusted Business",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rzShield",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#62C84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B9A3B"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 5 L57 13 L57 35 C57 51 47 60 33 66 C19 60 9 51 9 35 L9 13 Z",
    fill: "url(#rzShield)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 5 L57 13 L57 35 C57 51 47 60 33 66 C19 60 9 51 9 35 L9 13 Z",
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.35,
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16 L43 16 L37 32 L30 32 Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 16 L41 16 L27 56 L21 56 Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 36 L37 36 L33 47 L27 47 Z",
    fill: "#9FE38C"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 34,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontStyle: "italic",
    fontWeight: 700,
    fontSize: 26,
    fill: "#0B1F44"
  }, "Razorpay")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 77,
    y: 56,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 16,
    letterSpacing: 1.5,
    fill: "#2563C9"
  }, "TRUSTED BUSINESS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRazorpayTrusted);
export default __webpack_public_path__ + "static/media/razorpay-trusted.47f18f498fa7bf575e866c8e57c2a553.svg";
export { ForwardRef as ReactComponent };